import Footer from "@/components/Footer";
import HelioLogoMark from "@/components/HelioLogoMark";
import HeaderAuth from "@/components/HeaderAuth";
import SiteNav from "@/components/marketing/SiteNav";
import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";

interface MarketingLayoutProps {
  children: React.ReactNode;
  variant?: "dark" | "home";
}

export default function MarketingLayout({ children, variant = "dark" }: MarketingLayoutProps) {
  if (variant === "home") {
    return (
      <div className="home-light min-h-screen overflow-x-hidden flex flex-col">
        <SiteNav />
        <main className="flex-1" data-nav-tone="light">
          {children}
        </main>
        <Footer variant="light" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050d1a] text-white flex flex-col">
      <header className="border-b border-white/8 px-6 py-4">
        <div className="container flex items-center justify-between gap-3">
          <HelioLogoMark className="text-brand-lime" />
          <div className="flex items-center gap-3 shrink-0">
            <Link href="/blog" className="text-sm text-white/50 hover:text-white transition-colors">
              Insights
            </Link>
            <HeaderAuth />
            <Link
              href="/"
              className="flex items-center gap-2 text-sm text-white/50 hover:text-white transition-colors"
            >
              <ArrowLeft className="h-4 w-4" aria-hidden />
              <span className="hidden sm:inline">Back to home</span>
            </Link>
          </div>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
